var _rect, _g, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSmilingEmptyBook(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 200,
    height: 193,
    viewBox: "0 0 200 193",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 40,
    y: 33,
    width: 116,
    height: 116,
    fill: "white"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_dd_1642_5740)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M54.0583 60.5782C55.2784 60.1715 55.9902 58.8497 55.5835 57.6296C55.1768 56.4095 53.855 55.6977 52.5332 56.1044C51.313 56.5111 50.6013 57.8329 51.008 59.0531C51.4147 60.2732 52.7365 60.9849 54.0583 60.5782Z",
    fill: "#EAEEF9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.2439 52.8508C60.0573 52.5458 60.5657 51.6307 60.2607 50.8173C59.9557 50.0039 59.0406 49.4955 58.2272 49.8005C57.4137 50.1055 56.9054 51.0206 57.2104 51.834C57.4137 52.6474 58.3288 53.1558 59.2439 52.8508Z",
    fill: "#EAEEF9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.321 71.3285C146.846 70.0068 146.948 67.6682 145.524 66.2447C144.202 64.8212 141.864 64.7196 140.44 66.0414C138.915 67.3632 138.813 69.7017 140.237 71.1252C141.559 72.5487 143.897 72.6503 145.321 71.3285Z",
    fill: "#EAEEF9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.811 78.4532C151.421 77.8431 151.523 76.928 150.913 76.3179C150.303 75.7079 149.388 75.6062 148.778 76.2163C148.167 76.8263 148.066 77.7414 148.676 78.3515C149.184 79.0632 150.201 79.0632 150.811 78.4532Z",
    fill: "#EAEEF9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.2276 138.768C58.8377 138.158 58.9394 137.242 58.3293 136.632C57.7193 136.022 56.8042 135.921 56.1941 136.531C55.584 137.141 55.4824 138.056 56.0924 138.666C56.7025 139.276 57.6176 139.378 58.2276 138.768Z",
    fill: "#EAEEF9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.6614 143.75C122.792 143.75 144.043 122.601 144.043 96.5718C143.941 70.4409 122.792 49.2921 96.6614 49.2921C70.4288 49.2921 49.28 70.4409 49.28 96.4701C49.28 122.601 70.4288 143.75 96.6614 143.75Z",
    fill: "#F1F3F9",
    stroke: "#D6DCE8",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.105 72.1525V75.8064H127.824H124.264L69.6431 75.619C68.6125 75.619 67.582 75.4316 66.5514 75.1506C66.4577 75.1506 66.364 75.0569 66.2703 75.0569C64.9586 74.5884 63.8344 74.0263 62.8975 73.0894C62.148 72.3399 61.5858 71.2156 61.5858 70.185C61.5858 68.2175 63.1785 66.7185 65.4271 65.7816C66.1766 65.4068 67.1135 65.2195 68.0504 65.1258C68.4252 65.1258 68.7999 65.0321 69.1747 65.0321H120.985C121.547 65.0321 122.016 65.1258 122.484 65.2195C122.859 65.3131 123.234 65.4068 123.608 65.5942C126.325 66.7185 128.105 69.1544 128.105 72.1525Z",
    fill: "#F1F3F9",
    stroke: "#D6DCE8",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.758 81.5214V127.523C134.758 130.709 132.228 133.238 129.043 133.238H73.8597C69.2689 133.238 65.7087 131.083 63.4602 129.303C62.4296 128.46 61.7737 127.148 61.7737 125.837C61.7737 125.181 61.7737 124.525 61.7737 123.869C61.7737 122.932 61.7737 121.808 61.7737 120.684C61.7737 115.437 61.7737 108.41 61.6801 101.29C61.6801 100.259 61.6801 99.2288 61.6801 98.1045C61.6801 94.3569 61.6801 90.6093 61.5864 87.0491C61.5864 86.0185 61.5864 84.988 61.5864 83.8637C61.5864 76.837 61.4927 71.5903 61.4927 70.3724C61.4927 72.4335 63.4602 74.3073 66.0835 75.0569C66.1772 75.0569 66.2708 75.1505 66.3645 75.1505C67.3014 75.4316 68.4257 75.619 69.4563 75.619L124.077 75.9001H128.012H128.949C132.228 75.8064 134.758 78.336 134.758 81.5214Z",
    fill: "white",
    stroke: "#D6DCE8",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.758 94.5443V96.2307C134.664 96.2307 134.571 96.2307 134.383 96.2307H123.14C121.173 96.2307 119.487 96.9802 118.269 98.1982C117.144 99.3225 116.301 101.009 116.207 102.789C116.207 102.883 116.207 103.07 116.207 103.164C116.207 107.005 119.299 110.097 123.14 110.097H134.383C134.945 110.097 135.414 109.909 135.601 109.628C135.695 109.535 135.789 109.347 135.789 109.254V95.3875C135.789 94.9191 135.32 94.638 134.758 94.5443Z",
    fill: "white",
    stroke: "#D6DCE8",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.384 106.772C125.352 106.772 126.992 105.132 126.992 103.164C126.992 101.196 125.352 99.5556 123.384 99.5556C121.416 99.5556 119.776 101.196 119.776 103.164C119.776 105.132 121.416 106.772 123.384 106.772Z",
    fill: "#F1F3F9",
    stroke: "#D6DCE8",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M85.5 103C86.8542 103 88 101.396 88 99.5C88 97.6042 86.8542 96 85.5 96C84.1458 96 83 97.6042 83 99.5C83 101.396 84.1458 103 85.5 103Z",
    fill: "#AAB2C5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M107.5 103C108.854 103 110 101.396 110 99.5C110 97.6042 108.854 96 107.5 96C106.146 96 105 97.6042 105 99.5C105 101.542 106.146 103 107.5 103Z",
    fill: "#AAB2C5"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M97 115C101.971 115 106 111.922 106 110.591C106 109.261 101.971 111 97 111C92.0294 111 88 109.261 88 110.591C88 111.922 92.0294 115 97 115Z",
    fill: "#AAB2C5"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M146.651 41.7444C137.352 39.7052 127.4 40.0315 118.265 42.7233C116.389 43.2943 114.349 44.0284 112.881 45.3335C110.597 47.2096 109.618 50.5539 110.352 53.4088C111.087 56.2637 113.534 58.6292 116.552 59.2002C118.428 59.6896 120.712 59.037 121.854 57.4872C122.914 55.8558 122.669 53.4088 121.364 51.9405C120.059 50.3092 117.938 49.6566 115.981 49.7382C114.023 49.8197 112.065 50.5539 110.352 51.4511C104.806 54.4692 100.32 59.7711 98.4434 65.9704C97.4924 68.982 97.1574 72.1476 97.401 75.2614",
    stroke: "#C9D4E2",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeDasharray: "4 4"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M151.544 39.6236C151.462 40.8471 151.381 41.9891 150.483 42.2338C149.586 42.4785 149.178 41.6628 148.607 40.5208C148.036 39.4605 148.363 38.3185 149.341 38.0738C150.239 37.8291 151.707 38.1554 151.544 39.6236Z",
    fill: "#F1F3F9",
    stroke: "#D6DCE8",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M150.566 45.4966C150.811 44.0284 151.056 43.2127 150.24 42.8048C149.343 42.397 148.772 43.1311 147.793 44.1099C146.977 45.0072 147.467 46.3123 148.283 46.7201C149.261 47.2095 150.322 46.7201 150.566 45.4966Z",
    fill: "#F1F3F9",
    stroke: "#D6DCE8",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M151.708 42.8048C151.626 43.3758 151.218 43.7837 150.647 43.8652C150.402 43.8652 150.158 43.8652 149.831 43.8652C148.689 43.7021 147.792 42.968 147.874 42.2339C147.955 41.4997 149.016 41.0919 150.321 41.255C150.566 41.255 150.81 41.3366 150.973 41.4182C151.463 41.5813 151.789 42.1523 151.708 42.8048C151.708 42.8048 151.708 42.7233 151.708 42.8048Z",
    fill: "#F1F3F9"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M151.708 42.8048C151.626 43.3758 151.218 43.7837 150.647 43.8652C150.402 43.8652 150.158 43.8652 149.831 43.8652C148.689 43.7021 147.792 42.968 147.874 42.2339C147.955 41.4997 149.016 41.0919 150.321 41.255C150.566 41.255 150.81 41.3366 150.973 41.4182C151.463 41.5813 151.789 42.1523 151.708 42.8048ZM151.708 42.8048C151.708 42.7233 151.708 42.8048 151.708 42.8048Z",
    stroke: "#D6DCE8",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M61.9124 55.0802C61.9124 53.6935 61.9124 52.3068 62.8912 51.899C63.9516 51.4911 64.5226 52.47 65.3383 53.8566C66.0724 55.0802 65.7461 56.3852 64.6858 56.7931C63.7885 57.2009 61.9124 56.9562 61.9124 55.0802Z",
    fill: "#F1F3F9",
    stroke: "#D6DCE8",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M62.4833 48.2284C62.3202 49.9413 62.0755 50.9202 63.1359 51.328C64.1963 51.7359 64.7673 50.8386 65.8277 49.5335C66.6433 48.3915 66.0724 46.9233 65.012 46.5155C63.9516 46.1076 62.6465 46.8417 62.4833 48.2284Z",
    fill: "#F1F3F9",
    stroke: "#D6DCE8",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M61.5859 51.4911C61.5859 50.8386 62.0753 50.3492 62.6463 50.2676C62.891 50.186 63.2173 50.186 63.5436 50.2676C64.8487 50.3492 65.9906 51.0833 65.9091 51.899C65.8275 52.7147 64.7671 53.2856 63.3804 53.1225C63.1357 53.1225 62.891 53.0409 62.6463 52.9594C61.9938 52.8778 61.5859 52.2252 61.5859 51.4911Z",
    fill: "#F1F3F9",
    stroke: "#D6DCE8",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M67.1321 51.7358C75.6968 51.7358 91.5211 56.7115 91.7658 74.9829",
    stroke: "#C9D4E2",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeDasharray: "4 4"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_dd_1642_5740",
    x: 0.280029,
    y: 0.29213,
    width: 199.043,
    height: 192.458,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 24
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.513726 0 0 0 0 0.556863 0 0 0 0 0.619608 0 0 0 0.08 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1642_5740"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 12
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.384314 0 0 0 0 0.403922 0 0 0 0 0.431373 0 0 0 0.08 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_1642_5740",
    result: "effect2_dropShadow_1642_5740"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_1642_5740",
    result: "shape"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmilingEmptyBook);
export default __webpack_public_path__ + "static/media/SmilingEmptyBook.1e52ba81f03674dccde4b4dc7cf5d7f6.svg";
export { ForwardRef as ReactComponent };